exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n/* Styles non-scoped pour cacher le footer global sur les pages settings */\n.app-container.profile_update .footer-component,\r\n.app-container.friends_setting .footer-component,\r\n.app-container.identity_validation .footer-component,\r\n.app-container.identity_validation_manual .footer-component,\r\n.app-container.identity_validation_sms .footer-component {\r\n    display: none !important;\n}\r\n", ""]);

// exports
